import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const committeeRegularInviteesApi = {
    getCommitteeRegularInvitees: (committeeId: number): Observable<Dtos.GetCommitteeRegularInviteesResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeRegularInvitees = new Dtos.GetCommitteeRegularInvitees();
        request.committeeId = committeeId;

        //Send request.
        const response: Promise<Dtos.GetCommitteeRegularInviteesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getCommitteeRegularInviteeById: (id: number): Observable<Dtos.GetCommitteeRegularInviteeByIdResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeRegularInviteeById = new Dtos.GetCommitteeRegularInviteeById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetCommitteeRegularInviteeByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getCommitteeRegularInviteeByCommitteeId: (committeeId: number): Observable<Dtos.GetCommitteeRegularInviteeByCommitteeIdResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeRegularInviteeByCommitteeId = new Dtos.GetCommitteeRegularInviteeByCommitteeId();

        request.committeeId = committeeId;

        //Send request.
        const response: Promise<Dtos.GetCommitteeRegularInviteeByCommitteeIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setCommitteeRegularInvitee: (committeeRegularInvitee: Dtos.CommitteeRegularInvitee): Observable<Dtos.SetCommitteeRegularInviteeResponse> => {

        let request: Dtos.SetCommitteeRegularInvitee = new Dtos.SetCommitteeRegularInvitee();

        request.committeeRegularInvitee = committeeRegularInvitee;

        // send request
        const response: Promise<Dtos.SetCommitteeRegularInviteeResponse> = client.post(request);

        return Observable.from(response);
    },
    createCommitteeRegularInvitee: (committeeId: number): Observable<Dtos.CreateCommitteeRegularInviteeResponse> => {
        //Create the request.
        let request: Dtos.CreateCommitteeRegularInvitee = new Dtos.CreateCommitteeRegularInvitee();

        request.committeeId = committeeId;

        //Send request.
        const response: Promise<Dtos.CreateCommitteeRegularInviteeResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateCommitteeRegularInvitee: (committeeRegularInvitee: Dtos.CommitteeRegularInvitee): Observable<Dtos.ValidateCommitteeRegularInviteeResponse> => {

        let request: Dtos.ValidateCommitteeRegularInvitee = new Dtos.ValidateCommitteeRegularInvitee();

        request.committeeRegularInvitee = committeeRegularInvitee;

        // send request
        const response: Promise<Dtos.ValidateCommitteeRegularInviteeResponse> = client.post(request);

        return Observable.from(response);
    },
}